export default "__VITE_ASSET__BLVo1nSk__"